module.exports = __webpack_public_path__ + "assets/logo_navbar_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_navbar_old.jpg
 ** module id = 225
 ** module chunks = 1
 **/